var buttonSlot = 'fx_e395032e_13qi7iy0';

export { buttonSlot };
//# sourceMappingURL=slot.vanilla.mjs.map
